import React from 'react'
import { useOnramper } from 'hooks/useOnramper'
import CommonPopup from 'components/ui-kit/CommonPopup'

const OnramperWidget = () => {
  const { onramperUrl, closeOnramperWidget, isDarkTheme } = useOnramper()

  if (!onramperUrl) return null

  const modalContentClass = isDarkTheme
    ? 'rounded-xl border-[1.5px] border-solid border-[#cb7d00] bg-[#1e1e1e] shadow-[0_10px_40px_rgba(0,0,0,0.55)]'
    : 'rounded-xl border-[1.5px] border-solid border-[#cb7d00] bg-white shadow-[0_10px_40px_rgba(0,0,0,0.18)]'

  const modalBodyClasses = isDarkTheme
    ? '!flex !items-center !justify-center !overflow-hidden !rounded-xl !bg-[#1e1e1e] !p-0'
    : '!flex !items-center !justify-center !overflow-hidden !rounded-xl !bg-white !p-0'

  return (
    <CommonPopup
      id='onramper-widget-modal'
      modalCloseHandler={closeOnramperWidget}
      classes={`onramper-modal ${isDarkTheme ? 'onramper-modal--dark' : 'onramper-modal--light'} !z-[99999]`}
      modalDialogClass='!max-w-[500px] !-translate-y-[50px] !z-[100000]'
      modalContentClass={modalContentClass}
      modalBodyClasses={modalBodyClasses}
    >
      <div
        className={`onramper-iframe-container ${isDarkTheme ? 'bg-[#1e1e1e]' : 'bg-white'}`}
        style={{ height: '700px', width: '100%', overflow: 'hidden', borderRadius: '12px' }}
      >
        <iframe
          src={onramperUrl}
          title='Onramper'
          frameBorder='0'
          style={{ width: '100%', height: '100%' }}
          allow='accelerometer; autoplay; camera; gyroscope; payment; microphone'
          allowFullScreen
        />
      </div>
    </CommonPopup>
  )
}

export default OnramperWidget
